import { SpaceMd, SpaceSm, SpaceXxs, ColorGray500, ColorTextLight, SpaceLg, FontSize200 } from "@nxt-costco-com/forge-design-tokens";
const containerStyles = {
  "& p": {
    margin: 0
  },
  alignItems: "stretch",
  display: "flex",
  flexDirection: "column",
  gap: SpaceMd,
  justifyContent: "space-between",
  position: "relative",
  textAlign: "left"
};
const containerStylesSponsoredBordered = {
  padding: SpaceSm,
  border: `1px solid ${ColorGray500}`,
  borderRadius: SpaceXxs,
  margin: `${SpaceSm} -${SpaceSm} 0`
};
const linkWrapperStyles = {
  "&:focus-visible": {
    borderRadius: "1px",
    outline: "2px solid -webkit-focus-ring-color",
    outlineOffset: "2px"
  },
  height: "100%",
  position: "absolute",
  width: "100%",
  zIndex: 1
};
const withSponsoredStyles = {
  bottom: `-${SpaceLg}`,
  color: ColorTextLight,
  marginTop: "12px",
  position: "absolute",
  right: 0
};
const withSponsoredStylesBordered = {
  ...withSponsoredStyles,
  top: "-36px",
  bottom: 0,
  right: "12px",
  fontSize: FontSize200,
  textTransform: "capitalize"
};
export {
  containerStyles,
  containerStylesSponsoredBordered,
  linkWrapperStyles,
  withSponsoredStyles,
  withSponsoredStylesBordered
};
